import { render, staticRenderFns } from "./DIMDDetail.vue?vue&type=template&id=4ee61c47&scoped=true"
import script from "./DIMDDetail.vue?vue&type=script&lang=js"
export * from "./DIMDDetail.vue?vue&type=script&lang=js"
import style0 from "./DIMDDetail.vue?vue&type=style&index=0&id=4ee61c47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee61c47",
  null
  
)

export default component.exports